import React from 'react';

class RefrigerantIcon extends React.Component {

    constructor(props) {
        super(props)
    }

    render() {
        if (this.props.product && this.props.product.categories && this.props.product.categories.filter((el) => el === "Kælir").length > 0) {
            return (
                <div className="refrigerant-icon mr-2" title="Varan er kælivara">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#15d9ca" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-thermometer-snowflake-icon lucide-thermometer-snowflake"><path d="m10 20-1.25-2.5L6 18" /><path d="M10 4 8.75 6.5 6 6" /><path d="M10.585 15H10" /><path d="M2 12h6.5L10 9" /><path d="M20 14.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0z" /><path d="m4 10 1.5 2L4 14" /><path d="m7 21 3-6-1.5-3" /><path d="m7 3 3 6h2" /></svg>
                </div>
            )
        } else {
            return null
        }
    }
}

RefrigerantIcon.defaultProps = {
    product: {
        categories: []
    }
}

export default RefrigerantIcon;